/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import { useState } from 'react';
import { useLocation, Navigate } from 'react-router';
import { useAppSelector } from 'common/stores/redux/hooks';
import { useAuthActions } from 'common/utils/hooks/useAuthActions';

import Login from './Login';

/**
 * Login
 *
 */
export default function LoginContainer() {
    const location = useLocation();

    const { processLogin, processForgotPassword } = useAuthActions();

    const { authenticated, loading } = useAppSelector(
        state => state.authentication
    );

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [forgotPasswordEmail, setForgotPasswordEmail] = useState('');
    const [forgotPassword, setForgotPassword] = useState(false);

    if (authenticated) {
        return <Navigate to={{ pathname: '/', search: location?.search }} />;
    }

    return (
        <Login
            handleLogin={handleLogin}
            login={handleLogin}
            email={email}
            password={password}
            handleEmailChange={email => setEmail(email)}
            handlePasswordChange={password => setPassword(password)}
            loading={loading}
            forgotPasswordEmail={forgotPasswordEmail}
            forgotPassword={forgotPassword}
            handleForgotPasswordEmailChange={forgotPasswordEmail =>
                setForgotPasswordEmail(forgotPasswordEmail)
            }
            handleForgotPasswordLinkClicked={handleForgotPasswordLinkClicked}
            handleForgotPassword={handleForgotPassword}
        />
    );

    async function handleLogin(e) {
        e.preventDefault();
        await processLogin(email, password);
    }

    async function handleForgotPassword(e) {
        e.preventDefault();
        await processForgotPassword(forgotPasswordEmail);
    }

    function handleForgotPasswordLinkClicked(boolean) {
        setForgotPassword(boolean);
    }
}
